import { AxiosBase } from "./config/axiosBase.instance"

export const getDistrictAPI = (provinceId: string) => {
   return AxiosBase.get("district/province/" + provinceId)
}
